import { Fragment, ReactElement, useMemo } from 'react';
import { DeathCancellationNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { DeathCancellationNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { DeathCancellationNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { DeathCancellationNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { DeathCancellationNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import CancellationNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-death-non-resident/detail';

interface CancellationNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
}

const CancellationNonResidentNotificationCivilStatusShared = ({
  scope,
  isOther,
}: CancellationNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return DeathCancellationNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return DeathCancellationNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return DeathCancellationNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return DeathCancellationNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return DeathCancellationNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <CancellationNonResidentNotificationShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isOther={isOther}
        editSipoUrl={`${goBackUrl}/morte/non-residenti/cancellazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo`}
      />
    </Fragment>
  );
};

CancellationNonResidentNotificationCivilStatusShared.displayName =
  'Research Death Detail Notifications Page component';

export default CancellationNonResidentNotificationCivilStatusShared;
